var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTheatreAndStageShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Show-Theater-Play--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Show Theater Play Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 19a3 3 0 0 0 -3 3v1.5a0.5 0.5 0 0 0 0.5 0.5h5a0.5 0.5 0 0 0 0.5 -0.5V22a3 3 0 0 0 -3 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19a3 3 0 0 0 -3 3v1.5a0.5 0.5 0 0 0 0.5 0.5h5a0.5 0.5 0 0 0 0.5 -0.5V22a3 3 0 0 0 -3 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19a3 3 0 0 0 -3 3v1.5a0.5 0.5 0 0 0 0.5 0.5h5a0.5 0.5 0 0 0 0.5 -0.5V22a3 3 0 0 0 -3 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49 17c-0.2 -4.48 -3 -4.48 -3 -4.48H0.5A0.5 0.5 0 0 0 0 13v3.5a1 1 0 0 0 1 1h4a0.5 0.5 0 0 0 0.49 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.5H3a1 1 0 0 0 0 -2H0.5a0.5 0.5 0 0 0 -0.5 0.5v1a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5h-2s-2.79 0 -3 4.48a0.49 0.49 0 0 0 0.5 0.52h4a1 1 0 0 0 1 -1V13a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 9.5H21a1 1 0 0 0 0 2h2.5a0.5 0.5 0 0 0 0.5 -0.5v-1a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0H1a1 1 0 0 0 -1 1v7a0.5 0.5 0 0 0 0.52 0.5A8.52 8.52 0 0 0 8 2.83a0.5 0.5 0 0 1 0.47 -0.33h7a0.5 0.5 0 0 1 0.47 0.33 8.52 8.52 0 0 0 7.5 5.65A0.5 0.5 0 0 0 24 8V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTheatreAndStageShows);
export default ForwardRef;